// extracted by mini-css-extract-plugin
export default {"empty":"PossibleVolunteersItem_empty__wlKYZ"};